import cx from 'classnames';
import React from 'react';

import * as styles from '../Form.module.css';

const TextArea = ({
	label,
	placeholder,
	name,
	required,
	guidance,
	handleChange,
	className = '',
}: {
	label?: string;
	placeholder?: string;
	name: string;
	required?: boolean;
	guidance?: string;
	handleChange?: any;
	className?: string;
}) => {
	return (
		<div className={cx(styles.field)}>
			{label && (
				<label htmlFor={name} className={styles.label}>
					{label}
				</label>
			)}
			<textarea
				name={name}
				id={name}
				cols="30"
				rows="10"
				required={required}
				data-nice-name={label}
				placeholder={placeholder}
				className={cx(styles.input, styles.textarea)}
				onChange={handleChange}
			></textarea>

			{guidance && <p className={styles.guidance}>{guidance}</p>}
		</div>
	);
};

export default TextArea;
